import React, { useEffect, useState } from "react";
import styles from './partList.module.css';
import styless from '../../../component/bomComps/BomListTable/bomListTable.module.css';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button, Grid,

} from "@mui/material";
import { Close, EditPart, Edituser, Leaf, Payment, Pdf, Refresh, View } from "../../../Svg";
import NestedUserHeader from "../../../component/reusable/NestedUserHeader";
import { styled } from '@mui/material/styles';
import Cards from "../../../component/reusable/Cards";
import BomListTable from "../../../component/bomComps/BomListTable/BomListTable";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bomDetailsThunk, createbomQuoteThunk, getMatchedProductsThunk, getSuppliersThunk, updateProductFromScheduleThunk } from "../../../redux/bomSlice";
import { fomateDate } from "../../../utils/fomateDate";
import { toast } from "react-toastify";
import { createwizardQuoteThunk, updateProductFromWizardThunk, wizardDetailsThunk } from "../../../redux/wizardSlice";
import SuppliersQuote from "../../bom/SuppliersQuote";
import { createexcessQuoteThunk, excessDetailsThunk, updateProductFromexcessThunk } from "../../../redux/excessSlice";


const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));



const ExcessQuote = () => {
  const { macthedProducts, suppliers } = useSelector((state) => state.bom)
  const { loading, refresh, excessEnquiryDetails } = useSelector((state) => state.excess);
  // const { refresh, excessEnquiryDetails } = useSelector((state) => state.bom);
  const navigate = useNavigate()
  const location = useLocation();
  const dispatch = useDispatch()
  const [editingProduct, setEditingProduct] = useState(null);
  const [newPartNumber, setNewPartNumber] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(null)

  const { id } = useParams()
  const [showSupplier, setShowSupplier] = useState(false)


  const [productData, setProductData] = useState([]);



  useEffect(() => {
    setProductData(excessEnquiryDetails?.partList)
  }, [excessEnquiryDetails])


  useEffect(() => {
    dispatch(excessDetailsThunk(id))
  }, [refresh])


  // Re-match only when the part numbers change, not on every quote price / MOQ keystroke
  const partNumbersKey = (productData || []).map((p) => p?.productNumber).join('|')
  useEffect(() => {
    if (productData?.length) dispatch(getMatchedProductsThunk(productData))
  }, [partNumbersKey])

  // Catalogue match for a part (by part number, so stale or reordered replies cannot misalign rows)
  const findMatch = (productNumber) => macthedProducts?.find((m) => m?.productNumber === productNumber)


  const handleChange = (index, field, value) => {
    const updatedProducts = [...productData];
    updatedProducts[index] = { ...updatedProducts[index], [field]: value }; // Add field dynamically
    setProductData(updatedProducts);
  };

  // Delete a product
  const handleDelete = (index) => {
    setProductData(productData?.filter((_, i) => i !== index));
  };

  // Refresh a row (reset the input fields)
  const handleRefresh = (index) => {
    const product = productData[index];
    const isExit = excessEnquiryDetails?.partList?.find((i) => i?.partNumber == product?.partNumber)
    setProductData((prevProducts) => {
      const updatedProducts = [...prevProducts];
      updatedProducts[index] = { _id: prevProducts[index]._id, productNumber: prevProducts[index]?.productNumber, quotePrice: isExit?.quotePrice, moq: isExit?.moq };
      return updatedProducts;
    });
  };

  // console.log(productData);

  const handleCancel = () => {
    excessEnquiryDetails?.partList?.map((i) => {
      setProductData(prevData =>
        prevData.map(product =>
          product.productNumber === i?.productNumber
            ? { ...product, quotePrice: i?.quotePrice, moq: i?.moq }
            : product
        )
      );

    })
  }

  console.log(productData, "productsssssssss");


  const handleSubmit = () => {
    const formattedData = productData.map((product) => {
      const manufacturer = findMatch(product?.productNumber)
      return ({
        productNumber: product?.productNumber,
        partId: product._id,
        quotePrice: product.quotePrice || 0,
        moq: product.moq || 0,
        manufacturer: manufacturer?.product?.productOverview?.manufacturer[0]?.name || product?.manufacturer,
      })
    }
    );

    console.log("Final Data:", formattedData);
    const finaldata = {
      id: excessEnquiryDetails?._id,
      data: formattedData
    }
    dispatch(createexcessQuoteThunk(finaldata))
  };


  const handleView = (index) => {
    setSelectedIndex(index)
    const product = productData[index];
    dispatch(getSuppliersThunk(`?productNumber=${product?.productNumber}&quantity=${product?.quantity}&enquiryId=${excessEnquiryDetails?._id}&manufacturer=${product?.manufacturer}&source=excess`))
    setShowSupplier(true)
  }


  const handleProductEdit = (index) => {
    const product = productData[index];
    const manufacturer = findMatch(product?.productNumber)

    const data = {
      id: excessEnquiryDetails?._id,
      partId: product._id,
      productNumber: product?.productNumber,
      manufacturer: manufacturer?.product?.productOverview?.manufacturer[0]?.name || product?.manufacturer,
      quotePrice: product.quotePrice || 0,
      moq: product.moq || 0,
    }
    dispatch(updateProductFromexcessThunk(data))
  }



  // Rows come from the enquiry's own parts so they always line up with the quote inputs on the right;
  // the catalogue match only adds product details (image, stock, prices) when the part exists
  const updatedProducts = (productData || []).map((part) => {
    const match = findMatch(part?.productNumber)
    return match
      ? { ...part, ...match, quantity: part?.quantity }
      : { ...part, status: false }
  });


  const handleSelectAlternate = (originalItem, alternateProductNumber) => {

    setProductData(prevData => {
      const isAlreadyExist = prevData.some(item => item.productNumber === alternateProductNumber);

      if (isAlreadyExist) {
        toast.error("Product already exists!");
        return prevData;
      }
      // Replace the product number
      return prevData.map(item =>
        item.productNumber === originalItem
          ? { ...item, productNumber: alternateProductNumber, manufacturer: '' } // Replace only productNumber
          : item
      );
    });
  };



  const handleEdit = () => {
    if (!newPartNumber) return;

    const isDuplicate = productData.some(item => item.productNumber === newPartNumber);
    if (isDuplicate) {
      toast.error("This part number already exists!");
      return;
    }
    setProductData(prevData =>
      prevData.map(item =>
        item.productNumber === editingProduct
          ? { ...item, productNumber: newPartNumber }
          : item
      )
    );
    setEditingProduct(null);
  };

  const handleEditClick = (product) => {
    setEditingProduct(product);
    setNewPartNumber(product);
  };


  return (
    <>
      <NestedUserHeader
        index={`Excess Enquiry #${id}`}
        root="Dashboard"
        buttonText={'Add Subcategory'}
      />


      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
          <Box display="flex" alignItems="center" >
            <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
              {productData?.length} Products
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
              Quoted date: {fomateDate(excessEnquiryDetails?.createdAt)}
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: excessEnquiryDetails?.status === "NEW" ? "#4A4C56" : excessEnquiryDetails?.status === "QUOTED" ? "#00B789" : "#1A9882" }}>
              {excessEnquiryDetails?.status}
            </Typography>
            {/* <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: '#E9BD21' }}>
              Pending
            </Typography> */}
          </Box>
          {excessEnquiryDetails?.status == "QUOTED" &&
            <Box display="flex" alignItems="center" >
              <ActionButton onClick={handleSubmit}> Edit Quote</ActionButton>
            </Box>
          }
        </Box>

        <div style={{ display: 'flex', gap: "10px" }}>
          <div style={{ width: '100%' }}>

            <BomListTable
              products={updatedProducts}
              handleSelectAlternate={handleSelectAlternate}
              editingProduct={editingProduct}
              newPartNumber={newPartNumber}
              setNewPartNumber={setNewPartNumber}
              handleSubmit={handleEdit}
              handleEditClick={handleEditClick}
              enquiryType={'excess'}
            />


          </div>
          <div style={{ width: '80%', marginTop: "20px" }}>
            <table className={styless.productTable22}>
              <thead className={styless.productTableHead22}>
                <tr style={{ height: 30 }}>
                  <th className={styless.partNumber}>Quote price</th>
                  <th className={styless.partNumber}>MOQ</th>
                  <th className={styless.partNumber}></th>
                </tr>
              </thead>
              <tbody>
                {productData?.map((product, index) => (
                  <tr key={product?._id} style={{ height: 100 }}>
                    <td className={`${styless.requiredQuantity} ${styless.tdBorder}`}>
                      <input
                        type="text"
                        placeholder="Enter"
                        className={styless.dataInput}
                        value={product.quotePrice || ""} // Default empty if not present
                        onChange={(e) => handleChange(index, "quotePrice", e.target.value)}
                      />
                    </td>
                    <td className={`${styless.requiredQuantity} ${styless.tdBorder}`}>
                      <input
                        type="text"
                        placeholder="Enter"
                        className={styless.dataInput}
                        value={product.moq || ""} // Default empty if not present
                        onChange={(e) => handleChange(index, "moq", e.target.value)}
                      />
                    </td>

                    <td className={`${styless.requiredQuantity} ${styless.tdBorder}`}>
                      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                        <div onClick={() => handleView(index)}><View /></div>
                        <div onClick={() => handleProductEdit(index)}>
                          <Edituser />
                        </div>
                        <div onClick={() => handleRefresh(index)} >
                          <Refresh />
                        </div>
                        <div onClick={() => handleDelete(index)}>
                          <Close />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {excessEnquiryDetails?.status == 'NEW' &&
          <div style={{ display: 'flex', justifyContent: "flex-end", gap: "20px", padding: "20px" }}>
            <button className={styless.quoteBtn} onClick={handleCancel}>Cancel</button>
            <button className={styless.addBtn} onClick={handleSubmit}>Submit Quote</button>
          </div>
        }

      </Paper>

      {showSupplier &&
        <div style={{ position: 'absolute', top: '20%', left: '30%', zIndex: 1, width: '100%' }}>
          <SuppliersQuote
            data={{ ...suppliers?.data, ...productData?.[selectedIndex] }}
            loadings={suppliers?.loading}
            setShowSupplier={setShowSupplier}
            enquiryType={'EXCESS'}
            handleView={handleView}
            selectedIndex={selectedIndex}
          />

        </div>
      }
    </>
  );
};

export default ExcessQuote;
